import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RbacAuthGuard } from '@geekbears/gb-ngrx-auth-basic';
import { Roles } from '@utils/roles';
import { AddUsersComponent, UsersListComponent } from './pages';
import { UserDetailsComponent } from './pages/user-details/user-details.component';
import { AdminUsersRouteNames } from '@core/presentation';

const routes: Routes = [
  {
    path: AdminUsersRouteNames.usersList,
    pathMatch: 'full',
    component: UsersListComponent,
    data: { roles: [Roles.companyAdministrator] },
    canActivate: [RbacAuthGuard],
  },
  {
    path: AdminUsersRouteNames.addUsers,
    pathMatch: 'full',
    component: AddUsersComponent,
    data: { roles: [Roles.companyAdministrator] },
    canActivate: [RbacAuthGuard],
  },
  {
    path: AdminUsersRouteNames.userDetails,
    pathMatch: 'full',
    component: UserDetailsComponent,
    data: { roles: [Roles.companyAdministrator] },
    canActivate: [RbacAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminUsersRoutingModule {}
